import async from "async";
import * as AdminService from '../services/adminService';
import {receiveParticipants} from "../actions/panelAction";

export const panelParticipantPageServices = (dispatch,params) => {
    return new Promise((resolve, failure) => {
        async.series([
            (cb) => {
                AdminService.getParticipants(params).then((res) => {
                    if (res.data.success) {
                        cb(null, res.data.success);
                    }
                })
                    .catch((err) => {

                    })
            }
        ], (err, result) => {
            dispatch(receiveParticipants(result[0],true));
            resolve(result);
        });
    });


};
